import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function StaffLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [passwort, setPasswort] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/personal/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password: passwort }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || data.error || 'Login fehlgeschlagen.');
        return;
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('staffData', JSON.stringify({ name: data.name, rolle: data.rolle }));
      navigate('/staff');
    } catch {
      setError('Verbindungsfehler. Bitte erneut versuchen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>👥</span>
          <span style={styles.logoText}>Personal</span>
        </div>
        <p style={styles.subtitle}>Turniertag-Login</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Benutzername</label>
            <input
              type="text"
              required
              autoComplete="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={styles.input}
              placeholder="benutzername"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Passwort</label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={passwort}
              onChange={e => setPasswort(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{ ...styles.btn, opacity: loading ? 0.65 : 1 }}
          >
            {loading ? 'Wird geprüft…' : '👥 Einloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0d0d0d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  card: {
    width: '100%',
    maxWidth: 400,
    background: '#161616',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14,
    padding: '2.5rem 2rem',
    boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.6rem',
    marginBottom: '0.5rem',
  },
  logoIcon: { fontSize: '2rem', lineHeight: 1 },
  logoText: {
    fontSize: '1.6rem',
    fontWeight: 800,
    color: '#ffffff',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    textAlign: 'center',
    color: 'rgba(255,255,255,0.45)',
    fontSize: '0.85rem',
    marginTop: 0,
    marginBottom: '2rem',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  label: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: 'rgba(255,255,255,0.6)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  input: {
    background: '#0d0d0d',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 8,
    padding: '0.7rem 0.9rem',
    color: '#fff',
    fontSize: '0.95rem',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  error: {
    background: 'rgba(220,53,69,0.12)',
    border: '1px solid rgba(220,53,69,0.3)',
    borderRadius: 8,
    padding: '0.65rem 0.9rem',
    color: '#ff6b6b',
    fontSize: '0.875rem',
  },
  btn: {
    background: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '0.85rem',
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: '0.5rem',
  },
};
